import { UiSpacing } from "./figmaStyles.js";
export var UiTheme = /* @__PURE__ */ ((UiTheme2) => {
  UiTheme2["Primary"] = "primary";
  UiTheme2["Secondary"] = "secondary";
  UiTheme2["Tertiary"] = "tertiary";
  UiTheme2["Success"] = "success";
  UiTheme2["Outline"] = "outline";
  return UiTheme2;
})(UiTheme || {});
export const UiThemeAll = Object.values(UiTheme);
export var UiSize = /* @__PURE__ */ ((UiSize2) => {
  UiSize2["Large"] = "large";
  UiSize2["Big"] = "big";
  UiSize2["Medium"] = "medium";
  UiSize2["Small"] = "small";
  return UiSize2;
})(UiSize || {});
export const UiSizeAll = Object.values(UiSize);
export const UiStyles = {
  UiTheme,
  UiSize,
  UiSpacing
};
